import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import type { GlobalToastEvent } from "~/utils/globalToast";

/**
 * GlobalToastProvider - Listens for global toast events and displays them
 * This component should be mounted once at the app root level
 */
const GlobalToastProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const toastRef = useRef<Toast>(null);

  useEffect(() => {
    const handleGlobalToast = (event: CustomEvent<GlobalToastEvent>) => {
      const { severity, summary, detail, life } = event.detail;

      toastRef.current?.show({
        severity,
        summary,
        detail,
        life,
      });
    };

    const handleClearToast = () => {
      toastRef.current?.clear();
    };

    // Listen for global toast events
    window.addEventListener("global-toast", handleGlobalToast as EventListener);
    window.addEventListener("global-toast-clear", handleClearToast);

    return () => {
      window.removeEventListener(
        "global-toast",
        handleGlobalToast as EventListener,
      );
      window.removeEventListener("global-toast-clear", handleClearToast);
    };
  }, []);

  return (
    <>
      <Toast ref={toastRef} position="bottom-right" />
      {children}
    </>
  );
};

export default GlobalToastProvider;
